import { ApiClient } from "../ApiClient";
import config from "../utils/config";
class CurrencyApiClient {
    constructor() {
        this.apiClient = new ApiClient(`${config.gatewayApiUrl}/currency`);
    }
    getExchangeRates() {
        return this.apiClient.get('/exchange-rates');
    }
}
const currencyApiClient = new CurrencyApiClient();
export default currencyApiClient;
